import { render, staticRenderFns } from "./datasubject-transfering-form.vue?vue&type=template&id=e793ae00&scoped=true"
import script from "./datasubject-transfering-form.vue?vue&type=script&lang=js"
export * from "./datasubject-transfering-form.vue?vue&type=script&lang=js"
import style0 from "./datasubject-transfering-form.vue?vue&type=style&index=0&id=e793ae00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e793ae00",
  null
  
)

export default component.exports